type ConditionIdTuple = [unknown, string];
/** helper for making `aria-describedby` and `aria-labelledby` strings
 *
 * takes in tuples of `[condition, id]` and returns a space-separated
 * string with all the ids that have truthy conditions
 */
export const getAriaDescribedByString = (tuples: ConditionIdTuple[]): string =>
  tuples
    .filter(([condition]) => condition)
    .map(([, id]) => id)
    .join(' ');

// tiny helpers to tersely handle common event patterns
export const stopPropagation = (e: React.MouseEvent): void => e.stopPropagation();
export const preventDefault = (e: React.MouseEvent): void => e.preventDefault();

export const setFocusOnReactNativeElement = (
  _ref: null | undefined,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _timeout: number = 10
): void => {
  // No-op on the web, since focusing via AccessibilityInfo is RN-specific
};
